import { ADDON_TYPE } from '@shootsta/common-domain-data';

// Returns true only when a workspace has an *intentional* custom Voice Over
// Artist price configured, i.e. an admin either ticked it as included/free
// (`selected`) or typed a custom amount (`costChanged`). The Manage Add-on
// Prices modal always re-seeds a VOICE_OVER_ARTIST row with the standard
// default cost on save, so the mere presence of the entry (the old
// `addonValues.length > 0` test) is NOT a reliable signal — that default seed
// was silently flipping every long-script VO quote to the flat price and
// bypassing the word-count tiers (the IR "$295 for a 1032-word script" bug).
// Kept in its own dependency-light module so it can be unit-tested without
// pulling in getCost.js's heavy ui-kit import chain.
export default function hasCustomVoiceOverArtistCost(customAddonCosts = []) {
  return customAddonCosts.some(({ addonType, addonValues = [] }) => (
    addonType === ADDON_TYPE.VOICE_OVER_ARTIST &&
    addonValues.some((addonValue) => addonValue.costChanged || addonValue.selected)
  ));
}
